module.exports = __webpack_public_path__ + "img/clipboard-check.8c429933.svg";